// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2oUCh","buttons":"Footer_buttons__3LGrt"};